import React from "react";
import { 
    TextField,
    Button,
    Paper,
    Typography,
    FormControl,
    InputLabel,
    Input,
    CssBaseline
} from '@mui/material'
import RestUtilities from '../../services/RestUtilities';
import { RoutePaths } from '../../components/Routes';
import { truncateSync, truncate } from 'fs';
import Loader from '../../components/Loader';
import { withRouter } from "../../components/Shared/withNavigate";

class Forgotten extends React.Component<any, any> {

    guid:string
    personalNr: React.RefObject<HTMLInputElement>

    constructor(props: any) {
        super(props)

        const params = new URLSearchParams(this.props.router.location.search)
        const guid = params.get('guid')

        if(typeof guid != 'undefined' && guid != null) {
            this.guid = guid
        } else {
            this.personalNr = React.createRef()
        }
    }

    state = {
        active: null as boolean,
        password: '',
        passwordConfirm: '',
        loading: false
    }

    handleChangeField = (event: any): void => {
        const newModel = {...this.state}
        
        const name = event.target.name
        if(name === 'password')
            newModel.password = event.target.value
        else if(name === 'passwordConfirm')
            newModel.passwordConfirm = event.target.value
        
        this.setState(newModel)
    }

    sendEmail = (): void => {
        this.setState({ loading: true })
        RestUtilities.get(`/api/PasswordReset/Reset?personalNumber=${this.personalNr.current.value}`)
            .then(resp => {
                this.props.router.navigate(RoutePaths.RegisterComplete)
            }).catch(resp => {
                this.setState({ loading: false })
            })
    }

    checkIfLinkIsActive = (): void => {
        this.setState({ loading: true })
        RestUtilities.get<boolean>(`/api/PasswordReset/IsLinkActive?guid=${this.guid}`)
            .then(resp => {
                this.setState({ active: resp.content, loading: false })
            }).catch(resp => {
                this.setState({ loading: true })
            })
    }

    submitChangePassword = (): void => {
        const { password, passwordConfirm } = this.state
        if(password !== passwordConfirm) 
            return
        
        let formData = {
            guid: this.guid,
            password: this.state.password,
            passwordConfirm: this.state.passwordConfirm
        }
        this.setState({ loading: true })
        RestUtilities.post<any>('/api/PasswordReset/Submit', formData)
            .then(resp => {
                this.props.router.navigate(RoutePaths.SignIn);
            }).catch(resp => {
                this.setState({ loading: false })
            })
    }

    componentDidMount() {
        if(typeof this.guid != 'undefined' && this.guid !== null)
            this.checkIfLinkIsActive()
    }

    public render() {
        return (
        <div className='row'>
            <div className='col-lg-4 col-md-4 col-sm-4 col-xs-12 offset-lg-4 offset-md-4 offset-sm-4'>
                    {
                        this.guid == null &&
                        <>
                            <FormControl margin='normal' fullWidth>
                                <InputLabel>Personalnummer</InputLabel>
                                <Input
                                    type='text'
                                    inputRef={this.personalNr}
                                    fullWidth />
                            </FormControl>
                            <Button
                                className='btnBlue mt-3'
                                color='primary'
                                variant="contained"
                                onClick={() => this.sendEmail()}>Passwort zurücksetzen</Button>
                        </>
                    }
                    {
                        this.guid != null && this.state.active == true &&
                        <main className='main'>

                            <Paper className='paper'>
                                <form>
                                    <Typography variant='body1'>

                                        Bitte geben Sie ihr neues Passwort ein.
                            </Typography>
                                    <FormControl margin="normal" fullWidth>
                                        <InputLabel htmlFor="newPassword">Neues Passwort *</InputLabel>
                                        <Input
                                            name="password"
                                            autoFocus
                                            type="password"
                                            value={this.state.password}
                                            onChange={(e:any) => this.handleChangeField(e)} />
                                    </FormControl>
                                    <FormControl margin="normal" required fullWidth>
                                        <InputLabel htmlFor="newPasswordConfirm">Passwort wiederholen *</InputLabel>
                                        <Input
                                            name="passwordConfirm"
                                            type="password"
                                            value={this.state.passwordConfirm}
                                            onChange={(e:any) => this.handleChangeField(e)} />
                                    </FormControl>
                                    <CssBaseline />
                                    <Button
                                        type="button"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className='btnBlue'
                                        onClick={() => this.submitChangePassword()}
                                    >
                                        Speichern
                            </Button>
                                </form>
                            </Paper>

                        </main>
                    }
                    {
                        this.guid != null && this.state.active == false &&
                        <div className='alert alert-danger'>
                            Sorry, this link has expired!
                        </div>
                    }
                    {
                        this.state.loading &&
                        <Loader />
                    }
            </div>
        </div>
        )
    }
}

export default withRouter(Forgotten)